import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons";
import "react-js-cron/dist/cjs/styles.css";
import { white } from "utils/constants/colors";
const CronComponent = React.lazy(() => import("react-js-cron"));

const StyledCron = styled(CronComponent)`
  ${(props) =>
    ["month", "year"].includes(props.selectedPeriod) &&
    css`
      .react-js-cron-week-days {
        display: none;
      }
    `}
  div.react-js-cron-select {
    background: ${white};
  }
`;

const CronInfo = styled.div`
  span {
    font-size: 12px;
    margin-left: 5px;
  }
`;

export default function Cron(props) {
  const { t } = useTranslation();
  const [selectedPeriod, updateSelectedPeriod] = useState(props.value);
  const wrapRef = useRef(null);

  function selectPeriodEffect() {
    if (!wrapRef.current) {
      return;
    }
    const periodSelector = wrapRef.current.querySelector(
      ".react-js-cron-period .react-js-cron-select .ant-select-selector .ant-select-selection-search"
    );

    if (!periodSelector) {
      return;
    }

    const title = periodSelector.getAttribute("title");
    if (!title) {
      return;
    }
    updateSelectedPeriod(title);
  }

  useEffect(() => {
    selectPeriodEffect();
  }, []);

  const onCronChange = (value) => {
    props.onChange(value);
    selectPeriodEffect();
  };

  return (
    <div ref={wrapRef}>
      <StyledCron
        {...props}
        className="spectro-cron"
        selectedPeriod={selectedPeriod}
        setValue={onCronChange}
        ref={wrapRef}
      />
      <CronInfo>
        <div>
          <InfoCircleOutlined />
          <span>{t("UTC will be used for the schedule time")}</span>
        </div>
        <div>
          <InfoCircleOutlined />
          <span>
            {t(
              "Double click on a dropdown option to automatically select / unselect a periodicity"
            )}
          </span>
        </div>
      </CronInfo>
    </div>
  );
}
